import { default as ContentContainer } from './ContentContainer';

export default ContentContainer;
